import React from 'react'

const Splash: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      Carregando
    </div>
  )
}

export default Splash
